import axios from 'axios';
import { useEffect, useState, useRef } from 'react';

// 检测网络连接状态，使用健康检查接口，本地调试时，可以写成 /health，在 vite.config.ts 中配置代理
const DETECT_URL = ['/'];
const DETECT_TIMEOUT = 5000;

declare type StartDetect = () => void;
declare type StopDetect = () => void;
export interface IProps {
  onPingEnd?: (res: boolean) => void | Promise<void>;
}
export declare type UseDetectNetworkType = (props?: IProps) => [boolean, StartDetect, StopDetect];
const useNetworkDetect: UseDetectNetworkType = (props) => {
  const [isOnline, setIsOnline] = useState(true);
  const timerRef = useRef<number | null>(null);
  const checkUrl = async (url: string) => {
    try {
      await axios.head(`${url}?timestamps=${new Date().getTime()}`, {
        // 禁用缓存
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        },
      });
      return true;
    } catch (error) {
      console.error(url + '请求失败');
      return false;
    }
  };

  const startDetect = async () => {
    let param = false;
    try {
      const promises = DETECT_URL.map(async (url) => {
        const res = await checkUrl(url);
        if (res) {
          setIsOnline(true);
          param = true;
        } else {
          setIsOnline(false);
          param = false;
        }
      });
      await Promise.all(promises);
    } catch (error) {
      console.error('网络连接状态异常');
      setIsOnline(false);
      param = false;
    } finally {
      stopDetect();
      timerRef.current = window.setTimeout(startDetect, DETECT_TIMEOUT);
      await props?.onPingEnd?.(param);
    }
  };

  const stopDetect = () => {
    timerRef.current && window.clearTimeout(timerRef.current);
  };

  useEffect(() => {
    const offlineCb = () => {
      setTimeout(() => {
        setIsOnline(false);
        startDetect();
      }, 2000);
    };

    // 监听联网事件
    window.addEventListener('offline', offlineCb);
    return () => {
      stopDetect();
      window.removeEventListener('offline', offlineCb);
    };
  }, []);

  return [isOnline, startDetect, stopDetect];
};

export default useNetworkDetect;
